/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Features_Item_6_DescInputs */

const es_home_features_item_6_desc = /** @type {(inputs: Home_Features_Item_6_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexy, tu asistente que conversa con tu conocimiento empresarial.`)
};

const en_home_features_item_6_desc = /** @type {(inputs: Home_Features_Item_6_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexy, your assistant that converses with your enterprise knowledge.`)
};

/**
* | output |
* | --- |
* | "Nexy, your assistant that converses with your enterprise knowledge." |
*
* @param {Home_Features_Item_6_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_features_item_6_desc = /** @type {((inputs?: Home_Features_Item_6_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Features_Item_6_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_features_item_6_desc(inputs)
	return en_home_features_item_6_desc(inputs)
});
export { home_features_item_6_desc as "home.features.item_6_desc" }